// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ABYSSAL_REVERIE_TALENT: {
    id: 373054,
    name: 'Abyssal Reverie',
    icon: 'ability_priest_surgeofdarkness',
    maxRanks: 2,
    entryIds: [103709],
    definitionIds: [{ id: 108714, specId: 256 }],
  },
  AFTERLIFE_TALENT: {
    id: 196707,
    name: 'Afterlife',
    icon: 'inv_enchant_essencemagiclarge',
    maxRanks: 1,
    entryIds: [103771],
    definitionIds: [{ id: 108776, specId: 257 }],
  },
  ANCIENT_MADNESS_TALENT: {
    id: 1231346,
    name: 'Ancient Madness',
    icon: 'spell_priest_void_flay',
    maxRanks: 1,
    entryIds: [134052],
    definitionIds: [{ id: 138835, specId: 258 }],
  },
  ANGELIC_BULWARK_TALENT: {
    id: 108945,
    name: 'Angelic Bulwark',
    icon: 'ability_priest_angelicbulwark',
    maxRanks: 1,
    entryIds: [103821],
    definitionIds: [{ id: 108826, specId: 258 }],
  },
  ANGELIC_FEATHER_TALENT: {
    id: 121536,
    name: 'Angelic Feather',
    icon: 'ability_priest_angelicfeather',
    maxRanks: 1,
    entryIds: [103853],
    definitionIds: [{ id: 108858, specId: 258 }],
  },
  ANGELIC_TOUCH_TALENT: {
    id: 1250565,
    name: 'Angelic Touch',
    icon: 'spell_holy_hopeandgrace',
    maxRanks: 1,
    entryIds: [103762],
    definitionIds: [{ id: 108767, specId: 257 }],
  },
  ANGELS_MERCY_TALENT: {
    id: 238100,
    name: "Angel's Mercy",
    icon: 'spell_holy_testoffaith',
    maxRanks: 1,
    entryIds: [103831, 103828],
    definitionIds: [
      { id: 108836, specId: 257 },
      { id: 108833, specId: 258 },
    ],
  },
  APOTHEOSIS_TALENT: {
    id: 200183,
    name: 'Apotheosis',
    icon: 'ability_priest_ascension',
    maxRanks: 1,
    entryIds: [103748],
    definitionIds: [{ id: 108753, specId: 257 }],
  },
  ARCHANGEL_TALENT: {
    id: 197862,
    name: 'Archangel',
    icon: 'ability_priest_archangel',
    maxRanks: 1,
    entryIds: [103696],
    definitionIds: [{ id: 108701, specId: 256 }],
  },
  ASSURED_SAFETY_TALENT: {
    id: 440766,
    name: 'Assured Safety',
    icon: 'spell_holy_prayerofmendingtga',
    maxRanks: 1,
    entryIds: [117294],
    definitionIds: [{ id: 122306, specId: 257 }],
  },
  ATONEMENT_TALENT: {
    id: 81749,
    name: 'Atonement',
    icon: 'ability_priest_atonement',
    maxRanks: 1,
    entryIds: [103723],
    definitionIds: [{ id: 108728, specId: 256 }],
  },
  AUSPICIOUS_SPIRITS_TALENT: {
    id: 155271,
    name: 'Auspicious Spirits',
    icon: 'ability_priest_auspiciousspirits',
    maxRanks: 1,
    entryIds: [103811],
    definitionIds: [{ id: 108816, specId: 258 }],
  },
  BENEDICTION_1_HOLY_TALENT: {
    id: 1262755,
    name: 'Benediction',
    icon: 'inv12_apextalent_priest_benediction',
    maxRanks: 1,
    entryIds: [136995],
    definitionIds: [{ id: 141758, specId: 257 }],
  },
  BENEDICTION_2_HOLY_TALENT: {
    id: 1262758,
    name: 'Benediction',
    icon: 'inv12_apextalent_priest_benediction',
    maxRanks: 2,
    entryIds: [136994],
    definitionIds: [{ id: 141757, specId: 257 }],
  },
  BENEDICTION_3_HOLY_TALENT: {
    id: 1262760,
    name: 'Benediction',
    icon: 'inv12_apextalent_priest_benediction',
    maxRanks: 1,
    entryIds: [136993],
    definitionIds: [{ id: 141756, specId: 257 }],
  },
  BENEVOLENCE_TALENT: {
    id: 415416,
    name: 'Benevolence',
    icon: 'ability_priest_spiritoftheredeemer',
    maxRanks: 1,
    entryIds: [115884],
    definitionIds: [{ id: 120896, specId: 258 }],
  },
  BINDING_HEALS_TALENT: {
    id: 368275,
    name: 'Binding Heals',
    icon: 'spell_holy_blindingheal',
    maxRanks: 1,
    entryIds: [103825],
    definitionIds: [{ id: 108830, specId: 258 }],
  },
  BLAZE_OF_LIGHT_TALENT: {
    id: 215768,
    name: 'Blaze of Light',
    icon: 'spell_holy_searinglight',
    maxRanks: 2,
    entryIds: [103693],
    definitionIds: [{ id: 108698, specId: 256 }],
  },
  BODY_AND_SOUL_TALENT: {
    id: 64129,
    name: 'Body and Soul',
    icon: 'spell_holy_symbolofhope',
    maxRanks: 1,
    entryIds: [136185],
    definitionIds: [{ id: 140958, specId: 258 }],
  },
  BORROWED_TIME_TALENT: {
    id: 390691,
    name: 'Borrowed Time',
    icon: 'spell_holy_borrowedtime',
    maxRanks: 2,
    entryIds: [103697],
    definitionIds: [{ id: 108702, specId: 256 }],
  },
  BRIGHT_PUPIL_TALENT: {
    id: 390684,
    name: 'Bright Pupil',
    icon: 'spell_holy_surgeoflight',
    maxRanks: 1,
    entryIds: [103720],
    definitionIds: [{ id: 108725, specId: 256 }],
  },
  BURNING_VEHEMENCE_TALENT: {
    id: 372307,
    name: 'Burning Vehemence',
    icon: 'ability_paladin_sacredcleansing',
    maxRanks: 1,
    entryIds: [103739],
    definitionIds: [{ id: 108744, specId: 257 }],
  },
  CASTIGATION_TALENT: {
    id: 193134,
    name: 'Castigation',
    icon: 'spell_holy_searinglightpriest',
    maxRanks: 1,
    entryIds: [103700],
    definitionIds: [{ id: 108705, specId: 256 }],
  },
  CENSURE_TALENT: {
    id: 200199,
    name: 'Censure',
    icon: 'spell_holy_eyeforaneye',
    maxRanks: 1,
    entryIds: [103753],
    definitionIds: [{ id: 108758, specId: 257 }],
  },
  COLLAPSING_VOID_TALENT: {
    id: 448403,
    name: 'Collapsing Void',
    icon: 'inv_cosmicvoid_groundsate',
    maxRanks: 1,
    entryIds: [117297],
    definitionIds: [{ id: 122309, specId: 258 }],
  },
  COSMIC_RIPPLE_TALENT: {
    id: 238136,
    name: 'Cosmic Ripple',
    icon: 'inv_ability_holyfire_nova',
    maxRanks: 1,
    entryIds: [103765],
    definitionIds: [{ id: 108770, specId: 257 }],
  },
  COSMIC_WAVE_TALENT: {
    id: 1248418,
    name: 'Cosmic Wave',
    icon: 'inv_ability_holyfire_wave',
    maxRanks: 1,
    entryIds: [128333],
    definitionIds: [{ id: 133140, specId: 257 }],
  },
  CRISIS_MANAGEMENT_TALENT: {
    id: 390954,
    name: 'Crisis Management',
    icon: 'spell_holy_flashheal',
    maxRanks: 1,
    entryIds: [103763],
    definitionIds: [{ id: 108768, specId: 257 }],
  },
  CRUSHING_VOID_TALENT: {
    id: 1279354,
    name: 'Crushing Void',
    icon: 'inv12_ability_priest_voidvolley',
    maxRanks: 1,
    entryIds: [103797],
    definitionIds: [{ id: 108802, specId: 258 }],
  },
  DARKENING_HORIZON_TALENT: {
    id: 449912,
    name: 'Darkening Horizon',
    icon: 'inv_misc_83_voidfocus',
    maxRanks: 1,
    entryIds: [125982],
    definitionIds: [{ id: 130813, specId: 258 }],
  },
  DARK_ENERGY_TALENT: {
    id: 451018,
    name: 'Dark Energy',
    icon: 'achievement_boss_triumvirate_darknaaru',
    maxRanks: 1,
    entryIds: [123845],
    definitionIds: [{ id: 128683, specId: 258 }],
  },
  DARK_ENLIGHTENMENT_TALENT: {
    id: 1250835,
    name: 'Dark Enlightenment',
    icon: 'ability_priest_darkness',
    maxRanks: 1,
    entryIds: [134859],
    definitionIds: [{ id: 139627, specId: 258 }],
  },
  DARK_EVANGELISM_TALENT: {
    id: 391099,
    name: 'Dark Evangelism',
    icon: 'spell_mage_presenceofmind',
    maxRanks: 1,
    entryIds: [134051],
    definitionIds: [{ id: 138834, specId: 258 }],
  },
  DARK_INDULGENCE_TALENT: {
    id: 372972,
    name: 'Dark Indulgence',
    icon: 'spell_shadow_unholyfrenzy',
    maxRanks: 1,
    entryIds: [103725],
    definitionIds: [{ id: 108730, specId: 256 }],
  },
  DARK_THOUGHTS_TALENT: {
    id: 1240388,
    name: 'Dark Thoughts',
    icon: 'ability_priest_darkness',
    maxRanks: 1,
    entryIds: [103802],
    definitionIds: [{ id: 108807, specId: 258 }],
  },
  DEATHSPEAKER_TALENT: {
    id: 392507,
    name: 'Deathspeaker',
    icon: 'spell_shadow_demonicfortitude',
    maxRanks: 1,
    entryIds: [103681],
    definitionIds: [{ id: 108686, specId: 258 }],
  },
  DEATHS_TORMENT_TALENT: {
    id: 1240364,
    name: "Death's Torment",
    icon: 'spell_shadow_deathsembrace',
    maxRanks: 1,
    entryIds: [136828, 133377],
    definitionIds: [
      { id: 141591, specId: 256 },
      { id: 138163, specId: 258 },
    ],
  },
  DEATH_AND_MADNESS_TALENT: {
    id: 321291,
    name: 'Death and Madness',
    icon: 'ability_priest_thoughtsteal01',
    maxRanks: 1,
    entryIds: [134274],
    definitionIds: [{ id: 139047, specId: 258 }],
  },
  DESCENDING_DARKNESS_TALENT: {
    id: 1242666,
    name: 'Descending Darkness',
    icon: 'spell_holy_circleofrenewal_shadow',
    maxRanks: 1,
    entryIds: [103814],
    definitionIds: [{ id: 108819, specId: 258 }],
  },
  DESPERATE_MEASURES_TALENT: {
    id: 458718,
    name: 'Desperate Measures',
    icon: 'spell_holy_testoffaith',
    maxRanks: 1,
    entryIds: [126068],
    definitionIds: [{ id: 130900, specId: 257 }],
  },
  DESPERATE_PRAYER_TALENT: {
    id: 19236,
    name: 'Desperate Prayer',
    icon: 'spell_holy_testoffaith',
    maxRanks: 1,
    entryIds: [134846],
    definitionIds: [{ id: 139614, specId: 258 }],
  },
  DESPERATE_TIMES_TALENT: {
    id: 391381,
    name: 'Desperate Times',
    icon: 'ability_pvp_defenderoftheweak',
    maxRanks: 2,
    entryIds: [103741],
    definitionIds: [{ id: 108746, specId: 257 }],
  },
  DEVOUR_MATTER_TALENT: {
    id: 451840,
    name: 'Devour Matter',
    icon: 'spell_holy_consumemagic',
    maxRanks: 1,
    entryIds: [117271],
    definitionIds: [{ id: 122283, specId: 258 }],
  },
  DISPEL_MAGIC_TALENT: {
    id: 528,
    name: 'Dispel Magic',
    icon: 'spell_nature_nullifydisease',
    maxRanks: 1,
    entryIds: [103677],
    definitionIds: [{ id: 108682, specId: 258 }],
    manaCost: 5000,
  },
  DISPERSING_LIGHT_TALENT: {
    id: 1215265,
    name: 'Dispersing Light',
    icon: 'ability_priest_spiritoftheredeemer',
    maxRanks: 1,
    entryIds: [103735],
    definitionIds: [{ id: 108740, specId: 257 }],
  },
  DISTORTED_REALITY_TALENT: {
    id: 409044,
    name: 'Distorted Reality',
    icon: 'spell_shadow_gathershadows',
    maxRanks: 1,
    entryIds: [115671],
    definitionIds: [{ id: 120683, specId: 258 }],
  },
  DIVINE_AEGIS_TALENT: {
    id: 47515,
    name: 'Divine Aegis',
    icon: 'spell_holy_devineaegis',
    maxRanks: 1,
    entryIds: [103732],
    definitionIds: [{ id: 108737, specId: 256 }],
  },
  DIVINE_FEATHERS_TALENT: {
    id: 440670,
    name: 'Divine Feathers',
    icon: 'ability_priest_angelicfeather',
    maxRanks: 1,
    entryIds: [117278],
    definitionIds: [{ id: 122290, specId: 257 }],
  },
  DIVINE_HALO_TALENT: {
    id: 449806,
    name: 'Divine Halo',
    icon: 'inv_ability_holyfire_nova',
    maxRanks: 1,
    entryIds: [117305],
    definitionIds: [{ id: 122317, specId: 258 }],
  },
  DIVINE_HYMN_TALENT: {
    id: 64843,
    name: 'Divine Hymn',
    icon: 'spell_holy_divinehymn',
    maxRanks: 1,
    entryIds: [103755],
    definitionIds: [{ id: 108760, specId: 257 }],
    manaCost: 11000,
  },
  DIVINE_IMAGE_TALENT: {
    id: 392988,
    name: 'Divine Image',
    icon: 'inv_staff_2h_artifactheartofkure_d_04',
    maxRanks: 1,
    entryIds: [103675],
    definitionIds: [{ id: 108680, specId: 257 }],
  },
  DIVINE_PROCESSION_TALENT: {
    id: 472361,
    name: 'Divine Procession',
    icon: 'ability_priest_evangelism',
    maxRanks: 1,
    entryIds: [103728],
    definitionIds: [{ id: 108733, specId: 256 }],
  },
  DIVINE_SERVICE_TALENT: {
    id: 391233,
    name: 'Divine Service',
    icon: 'spell_holy_prayerofspirit',
    maxRanks: 1,
    entryIds: [103751],
    definitionIds: [{ id: 108756, specId: 257 }],
  },
  DIVINITY_TALENT: {
    id: 1215241,
    name: 'Divinity',
    icon: 'ability_priest_rayofhope',
    maxRanks: 1,
    entryIds: [128611],
    definitionIds: [{ id: 133414, specId: 257 }],
  },
  DOMINATE_MIND_TALENT: {
    id: 205364,
    name: 'Dominate Mind',
    icon: 'spell_priest_void_flay',
    maxRanks: 1,
    entryIds: [103678],
    definitionIds: [{ id: 108683, specId: 258 }],
    manaCost: 5000,
  },
  EFFICIENT_PRAYERS_TALENT: {
    id: 1247131,
    name: 'Efficient Prayers',
    icon: 'spell_priest_finalprayer',
    maxRanks: 1,
    entryIds: [103757],
    definitionIds: [{ id: 108762, specId: 257 }],
  },
  EMBRACE_THE_SHADOW_TALENT: {
    id: 451569,
    name: 'Embrace the Shadow',
    icon: 'spell_shadow_shadesofdarkness',
    maxRanks: 1,
    entryIds: [123844],
    definitionIds: [{ id: 128682, specId: 258 }],
  },
  EMPOWERED_SURGES_TALENT: {
    id: 453799,
    name: 'Empowered Surges',
    icon: 'ability_priest_flashoflight',
    maxRanks: 1,
    entryIds: [117291],
    definitionIds: [{ id: 122303, specId: 258 }],
  },
  EMPYREAL_BLAZE_TALENT: {
    id: 372616,
    name: 'Empyreal Blaze',
    icon: 'ability_priest_empyrealblaze',
    maxRanks: 1,
    entryIds: [103777],
    definitionIds: [{ id: 108782, specId: 257 }],
  },
  ENCROACHING_SHADOWS_TALENT: {
    id: 472568,
    name: 'Encroaching Shadows',
    icon: 'spell_shadow_painspike',
    maxRanks: 1,
    entryIds: [103704],
    definitionIds: [{ id: 108709, specId: 256 }],
  },
  ENDURING_LUMINESCENCE_TALENT: {
    id: 390685,
    name: 'Enduring Luminescence',
    icon: 'ability_priest_holybolts01',
    maxRanks: 1,
    entryIds: [103719],
    definitionIds: [{ id: 108724, specId: 256 }],
  },
  ENERGY_COMPRESSION_TALENT: {
    id: 449874,
    name: 'Energy Compression',
    icon: 'spell_holy_circleofrenewal',
    maxRanks: 1,
    entryIds: [117281],
    definitionIds: [{ id: 122293, specId: 258 }],
  },
  ENERGY_CONSERVATION_TALENT: {
    id: 1272308,
    name: 'Energy Conservation',
    icon: 'ability_priest_clarityofpurpose',
    maxRanks: 1,
    entryIds: [117283],
    definitionIds: [{ id: 122295, specId: 258 }],
  },
  ENERGY_CYCLE_TALENT: {
    id: 453828,
    name: 'Energy Cycle',
    icon: 'ability_priest_voidshift',
    maxRanks: 1,
    entryIds: [117288],
    definitionIds: [{ id: 122300, specId: 258 }],
  },
  ENLIGHTENMENT_TALENT: {
    id: 193155,
    name: 'Enlightenment',
    icon: 'spell_arcane_mindmastery',
    maxRanks: 1,
    entryIds: [103752],
    definitionIds: [{ id: 108757, specId: 257 }],
  },
  ENTROPIC_RIFT_TALENT: {
    id: 447444,
    name: 'Entropic Rift',
    icon: 'inv_ability_voidweaverpriest_entropicrift',
    maxRanks: 1,
    entryIds: [136498],
    definitionIds: [{ id: 141271, specId: 256 }],
  },
  EPIPHANY_TALENT: {
    id: 414553,
    name: 'Epiphany',
    icon: 'ability_mage_studentofthemind',
    maxRanks: 1,
    entryIds: [103740],
    definitionIds: [{ id: 108745, specId: 257 }],
  },
  ETERNAL_BARRIER_TALENT: {
    id: 238135,
    name: 'Eternal Barrier',
    icon: 'spell_holy_powerwordshield',
    maxRanks: 1,
    entryIds: [103688],
    definitionIds: [{ id: 108693, specId: 256 }],
  },
  ETERNAL_SANCTITY_TALENT: {
    id: 1215245,
    name: 'Eternal Sanctity',
    icon: 'ability_priest_archangel',
    maxRanks: 1,
    entryIds: [128612],
    definitionIds: [{ id: 133415, specId: 257 }],
  },
  EVANGELISM_TALENT: {
    id: 472433,
    name: 'Evangelism',
    icon: 'spell_holy_divineillumination',
    maxRanks: 1,
    entryIds: [103702],
    definitionIds: [{ id: 108707, specId: 256 }],
  },
  EVERLASTING_LIGHT_TALENT: {
    id: 1249233,
    name: 'Everlasting Light',
    icon: 'spell_holy_greaterheal',
    maxRanks: 1,
    entryIds: [103852],
    definitionIds: [{ id: 108857, specId: 258 }],
  },
  EXPIATION_TALENT: {
    id: 390832,
    name: 'Expiation',
    icon: 'spell_shadow_shadowpower',
    maxRanks: 2,
    entryIds: [103711],
    definitionIds: [{ id: 108716, specId: 256 }],
  },
  FADE_TALENT: {
    id: 586,
    name: 'Fade',
    icon: 'spell_magic_lesserinvisibilty',
    maxRanks: 1,
    entryIds: [134849],
    definitionIds: [{ id: 139617, specId: 258 }],
  },
  FALSE_AUTONOMY_TALENT: {
    id: 1250806,
    name: 'False Autonomy',
    icon: 'spell_arcane_mindmastery',
    maxRanks: 1,
    entryIds: [134841],
    definitionIds: [{ id: 139609, specId: 258 }],
  },
  FOCUSED_OUTBURST_TALENT: {
    id: 1272320,
    name: 'Focused Outburst',
    icon: 'ability_priest_spiritoftheredeemer',
    maxRanks: 1,
    entryIds: [136035],
    definitionIds: [{ id: 140790, specId: 258 }],
  },
  FOCUSED_POWER_TALENT: {
    id: 1249230,
    name: 'Focused Power',
    icon: 'ability_priest_focusedwill',
    maxRanks: 1,
    entryIds: [135091],
    definitionIds: [{ id: 139859, specId: 258 }],
  },
  FORESEEN_CIRCUMSTANCES_TALENT: {
    id: 440738,
    name: 'Foreseen Circumstances',
    icon: 'spell_holy_painsupression',
    maxRanks: 1,
    entryIds: [117292],
    definitionIds: [{ id: 122304, specId: 257 }],
  },
  GALES_OF_SONG_TALENT: {
    id: 372370,
    name: 'Gales of Song',
    icon: 'inv_misc_volatileair',
    maxRanks: 1,
    entryIds: [128316],
    definitionIds: [{ id: 133123, specId: 257 }],
  },
  GREATER_SMITE_TALENT: {
    id: 1253724,
    name: 'Greater Smite',
    icon: 'spell_paladin_inquisition',
    maxRanks: 2,
    entryIds: [103694],
    definitionIds: [{ id: 108699, specId: 256 }],
  },
  GUARDIAN_ANGEL_TALENT: {
    id: 200209,
    name: 'Guardian Angel',
    icon: 'ability_priest_pathofthedevout',
    maxRanks: 1,
    entryIds: [128315],
    definitionIds: [{ id: 133122, specId: 257 }],
  },
  GUARDIAN_SPIRIT_TALENT: {
    id: 47788,
    name: 'Guardian Spirit',
    icon: 'spell_holy_guardianspirit',
    maxRanks: 1,
    entryIds: [103774],
    definitionIds: [{ id: 108779, specId: 257 }],
  },
  GUIDING_LIGHT_TALENT: {
    id: 1248423,
    name: 'Guiding Light',
    icon: 'ability_priest_holywordlife',
    maxRanks: 1,
    entryIds: [117286],
    definitionIds: [{ id: 122298, specId: 257 }],
  },
  HALO_HOLY_TALENT: {
    id: 120517,
    name: 'Halo',
    icon: 'ability_priest_halo',
    maxRanks: 1,
    entryIds: [134273],
    definitionIds: [{ id: 139046, specId: 257 }],
    manaCost: 6750,
  },
  HALO_SHADOW_TALENT: {
    id: 120644,
    name: 'Halo',
    icon: 'ability_priest_halo_shadow',
    maxRanks: 1,
    entryIds: [117300],
    definitionIds: [{ id: 122312, specId: 258 }],
    manaCost: 6750,
  },
  HARSH_DISCIPLINE_TALENT: {
    id: 373180,
    name: 'Harsh Discipline',
    icon: 'ability_paladin_handoflight',
    maxRanks: 2,
    entryIds: [103729],
    definitionIds: [{ id: 108734, specId: 256 }],
  },
  HAUNTING_SHADOWS_TALENT: {
    id: 1279355,
    name: 'Haunting Shadows',
    icon: 'inv12_ability_priest_madness_wisp',
    maxRanks: 1,
    entryIds: [103799],
    definitionIds: [{ id: 108804, specId: 258 }],
  },
  HEALING_FOCUS_TALENT: {
    id: 1247166,
    name: 'Healing Focus',
    icon: 'spell_holy_healingfocus',
    maxRanks: 1,
    entryIds: [103770],
    definitionIds: [{ id: 108775, specId: 257 }],
  },
  HEIGHTENED_ALTERATION_TALENT: {
    id: 453729,
    name: 'Heightened Alteration',
    icon: 'inv_enchant_essenceeternallarge',
    maxRanks: 1,
    entryIds: [136687],
    definitionIds: [{ id: 141459, specId: 258 }],
  },
  HOLY_CELERITY_TALENT: {
    id: 1215275,
    name: 'Holy Celerity',
    icon: 'spell_priest_pathofdevout',
    maxRanks: 1,
    entryIds: [103745],
    definitionIds: [{ id: 108750, specId: 257 }],
  },
  HOLY_FIRE_TALENT: {
    id: 14914,
    name: 'Holy Fire',
    icon: 'spell_holy_searinglight',
    maxRanks: 1,
    entryIds: [134283],
    definitionIds: [{ id: 139056, specId: 257 }],
  },
  HOLY_NOVA_TALENT: {
    id: 132157,
    name: 'Holy Nova',
    icon: 'spell_holy_holynova',
    maxRanks: 1,
    entryIds: [103870],
    definitionIds: [{ id: 108875, specId: 258 }],
  },
  HOLY_RAY_TALENT: {
    id: 372969,
    name: 'Holy Ray',
    icon: 'ability_paladin_infusionoflight',
    maxRanks: 1,
    entryIds: [103718],
    definitionIds: [{ id: 108723, specId: 256 }],
  },
  HOLY_WORD_CHASTISE_TALENT: {
    id: 88625,
    name: 'Holy Word: Chastise',
    icon: 'spell_holy_chastise',
    maxRanks: 1,
    entryIds: [103776],
    definitionIds: [{ id: 108781, specId: 257 }],
  },
  HOLY_WORD_SANCTIFY_TALENT: {
    id: 34861,
    name: 'Holy Word: Sanctify',
    icon: 'spell_holy_divineprovidence',
    maxRanks: 1,
    entryIds: [103766],
    definitionIds: [{ id: 108771, specId: 257 }],
    manaCost: 8313,
  },
  HOLY_WORD_SERENITY_TALENT: {
    id: 2050,
    name: 'Holy Word: Serenity',
    icon: 'spell_holy_persuitofjustice',
    maxRanks: 1,
    entryIds: [103775],
    definitionIds: [{ id: 108780, specId: 257 }],
    manaCost: 5938,
  },
  IDOL_OF_CTHUN_TALENT: {
    id: 377349,
    name: "Idol of C'Thun",
    icon: 'achievement_boss_cthun',
    maxRanks: 1,
    entryIds: [103782],
    definitionIds: [{ id: 108787, specId: 258 }],
  },
  IDOL_OF_NZOTH_TALENT: {
    id: 373280,
    name: "Idol of N'Zoth",
    icon: 'inv_eyeofnzothpet',
    maxRanks: 1,
    entryIds: [103781],
    definitionIds: [{ id: 108786, specId: 258 }],
  },
  IDOL_OF_YOGG_SARON_TALENT: {
    id: 373273,
    name: 'Idol of Yogg-Saron',
    icon: 'achievement_boss_heraldvolazj',
    maxRanks: 1,
    entryIds: [103817],
    definitionIds: [{ id: 108822, specId: 258 }],
  },
  IDOL_OF_YSHAARJ_TALENT: {
    id: 373310,
    name: "Idol of Y'Shaarj",
    icon: 'achievement_raid_terraceofendlessspring04',
    maxRanks: 1,
    entryIds: [103787],
    definitionIds: [{ id: 108792, specId: 258 }],
  },
  IMPROVED_FADE_TALENT: {
    id: 390670,
    name: 'Improved Fade',
    icon: 'spell_magic_lesserinvisibilty',
    maxRanks: 2,
    entryIds: [103836],
    definitionIds: [{ id: 108841, specId: 258 }],
  },
  IMPROVED_FLASH_HEAL_TALENT: {
    id: 393870,
    name: 'Improved Flash Heal',
    icon: 'spell_holy_heal',
    maxRanks: 1,
    entryIds: [103869],
    definitionIds: [{ id: 108874, specId: 258 }],
  },
  IMPROVED_PURIFY_TALENT: {
    id: 390632,
    name: 'Improved Purify',
    icon: 'spell_holy_nullifydisease',
    maxRanks: 1,
    entryIds: [103855],
    definitionIds: [{ id: 108860, specId: 257 }],
  },
  IMPROVED_VOIDFORM_TALENT: {
    id: 341240,
    name: 'Improved Voidform',
    icon: 'spell_priest_void_blast',
    maxRanks: 1,
    entryIds: [103798],
    definitionIds: [{ id: 108803, specId: 258 }],
  },
  INCESSANT_SCREAMS_TALENT: {
    id: 453918,
    name: 'Incessant Screams',
    icon: 'spell_shadow_psychicscream',
    maxRanks: 1,
    entryIds: [125083],
    definitionIds: [{ id: 129915, specId: 258 }],
  },
  INDEMNITY_TALENT: {
    id: 373049,
    name: 'Indemnity',
    icon: 'ability_priest_clarityofwill',
    maxRanks: 1,
    entryIds: [108226],
    definitionIds: [{ id: 113231, specId: 256 }],
  },
  INESCAPABLE_TORMENT_TALENT: {
    id: 373427,
    name: 'Inescapable Torment',
    icon: 'spell_shadow_chilltouch',
    maxRanks: 1,
    entryIds: [136830, 103783],
    definitionIds: [
      { id: 141593, specId: 256 },
      { id: 108788, specId: 258 },
    ],
  },
  INNER_FOCUS_TALENT: {
    id: 390693,
    name: 'Inner Focus',
    icon: 'spell_frost_windwalkon',
    maxRanks: 1,
    entryIds: [103731],
    definitionIds: [{ id: 108736, specId: 256 }],
  },
  INNER_QUIETUS_TALENT: {
    id: 448278,
    name: 'Inner Quietus',
    icon: 'inv_cosmicvoid_buff',
    maxRanks: 1,
    entryIds: [117273],
    definitionIds: [{ id: 122285, specId: 258 }],
  },
  INSIDIOUS_IRE_TALENT: {
    id: 373212,
    name: 'Insidious Ire',
    icon: 'spell_fire_twilightcano',
    maxRanks: 2,
    entryIds: [103683],
    definitionIds: [{ id: 108688, specId: 258 }],
  },
  INSPIRATION_TALENT: {
    id: 390676,
    name: 'Inspiration',
    icon: 'spell_holy_layonhands',
    maxRanks: 1,
    entryIds: [103846],
    definitionIds: [{ id: 108851, specId: 258 }],
  },
  INSTILLED_DOUBT_TALENT: {
    id: 1242862,
    name: 'Instilled Doubt',
    icon: 'spell_shadow_shadowwordpain',
    maxRanks: 2,
    entryIds: [133549],
    definitionIds: [{ id: 138335, specId: 258 }],
  },
  INTANGIBILITY_TALENT: {
    id: 288733,
    name: 'Intangibility',
    icon: 'spell_shadow_dispersion',
    maxRanks: 1,
    entryIds: [134850],
    definitionIds: [{ id: 139618, specId: 258 }],
  },
  INVOKED_NIGHTMARE_TALENT: {
    id: 1279350,
    name: 'Invoked Nightmare',
    icon: 'inv12_ability_priest_madness_scream',
    maxRanks: 1,
    entryIds: [136811],
    definitionIds: [{ id: 141574, specId: 258 }],
  },
  LASTING_WORDS_TALENT: {
    id: 471504,
    name: 'Lasting Words',
    icon: 'spell_holy_renew',
    maxRanks: 1,
    entryIds: [103676],
    definitionIds: [{ id: 108681, specId: 257 }],
  },
  LEAP_OF_FAITH_TALENT: {
    id: 73325,
    name: 'Leap of Faith',
    icon: 'priest_spell_leapoffaith_a',
    maxRanks: 1,
    entryIds: [103867],
    definitionIds: [{ id: 108872, specId: 258 }],
    manaCost: 6500,
  },
  LENIENCE_TALENT: {
    id: 238063,
    name: 'Lenience',
    icon: 'ability_priest_atonement',
    maxRanks: 1,
    entryIds: [103727],
    definitionIds: [{ id: 108732, specId: 256 }],
  },
  LIGHTBURST_TALENT: {
    id: 1246549,
    name: 'Lightburst',
    icon: 'inv_ability_holyfire_nova',
    maxRanks: 1,
    entryIds: [103871],
    definitionIds: [{ id: 108876, specId: 258 }],
  },
  LIGHTS_INSPIRATION_TALENT: {
    id: 373450,
    name: "Light's Inspiration",
    icon: 'spell_holy_restoration',
    maxRanks: 1,
    entryIds: [103826],
    definitionIds: [{ id: 108831, specId: 258 }],
  },
  LIGHTS_PROMISE_TALENT: {
    id: 322115,
    name: "Light's Promise",
    icon: 'spell_priest_power_word',
    maxRanks: 1,
    entryIds: [103721],
    definitionIds: [{ id: 108726, specId: 256 }],
  },
  LIGHTS_RESURGENCE_TALENT: {
    id: 193157,
    name: "Light's Resurgence",
    icon: 'spell_monk_diffusemagic',
    maxRanks: 1,
    entryIds: [103779],
    definitionIds: [{ id: 108784, specId: 257 }],
  },
  LIGHTWEAVER_TALENT: {
    id: 390992,
    name: 'Lightweaver',
    icon: 'spell_holy_greaterheal',
    maxRanks: 1,
    entryIds: [103734],
    definitionIds: [{ id: 108739, specId: 257 }],
  },
  LIGHT_IN_THE_DARKNESS_TALENT: {
    id: 471668,
    name: 'Light in the Darkness',
    icon: 'spell_holy_divineprovidence',
    maxRanks: 2,
    entryIds: [128331],
    definitionIds: [{ id: 133138, specId: 257 }],
  },
  LIGHT_OF_THE_NAARU_TALENT: {
    id: 196985,
    name: 'Light of the Naaru',
    icon: 'inv_pet_naaru',
    maxRanks: 2,
    entryIds: [103764],
    definitionIds: [{ id: 108769, specId: 257 }],
  },
  MADDENING_TENTACLES_TALENT: {
    id: 1279353,
    name: 'Maddening Tentacles',
    icon: 'inv12_ability_priest_tentacleslam',
    maxRanks: 1,
    entryIds: [103796],
    definitionIds: [{ id: 108801, specId: 258 }],
  },
  MADDENING_TOUCH_TALENT: {
    id: 391228,
    name: 'Maddening Touch',
    icon: 'spell_holy_stoicism',
    maxRanks: 1,
    entryIds: [103805],
    definitionIds: [{ id: 108810, specId: 258 }],
  },
  MADNESS_WEAVING_TALENT: {
    id: 1240394,
    name: 'Madness Weaving',
    icon: 'spell_shadow_spectralsight',
    maxRanks: 2,
    entryIds: [103816],
    definitionIds: [{ id: 108821, specId: 258 }],
  },
  MANIFESTED_POWER_TALENT: {
    id: 453783,
    name: 'Manifested Power',
    icon: 'spell_holy_surgeoflight',
    maxRanks: 1,
    entryIds: [117302],
    definitionIds: [{ id: 122314, specId: 258 }],
  },
  MASS_DISPEL_TALENT: {
    id: 32375,
    name: 'Mass Dispel',
    icon: 'spell_arcane_massdispel',
    maxRanks: 1,
    entryIds: [136157],
    definitionIds: [{ id: 140912, specId: 258 }],
    manaCost: 20000,
  },
  MASTERMIND_TALENT: {
    id: 391151,
    name: 'Mastermind',
    icon: 'spell_nzinsanity_chasedbyshadows',
    maxRanks: 2,
    entryIds: [103784],
    definitionIds: [{ id: 108789, specId: 258 }],
  },
  MASTER_THE_DARKNESS_1_DISCIPLINE_TALENT: {
    id: 1253590,
    name: 'Master the Darkness',
    icon: 'inv12_apextalent_priest_voidshield',
    maxRanks: 1,
    entryIds: [136998],
    definitionIds: [{ id: 141761, specId: 256 }],
  },
  MASTER_THE_DARKNESS_2_DISCIPLINE_TALENT: {
    id: 1253845,
    name: 'Master the Darkness',
    icon: 'inv12_apextalent_priest_voidshield',
    maxRanks: 2,
    entryIds: [136997],
    definitionIds: [{ id: 141760, specId: 256 }],
  },
  MASTER_THE_DARKNESS_3_DISCIPLINE_TALENT: {
    id: 1253827,
    name: 'Master the Darkness',
    icon: 'inv12_apextalent_priest_voidshield',
    maxRanks: 1,
    entryIds: [136996],
    definitionIds: [{ id: 141759, specId: 256 }],
  },
  MENTAL_AGILITY_TALENT: {
    id: 341167,
    name: 'Mental Agility',
    icon: 'spell_holy_dispelmagic',
    maxRanks: 1,
    entryIds: [134852],
    definitionIds: [{ id: 139620, specId: 258 }],
  },
  MENTAL_DECAY_TALENT: {
    id: 375994,
    name: 'Mental Decay',
    icon: 'ability_kaztik_dominatemind',
    maxRanks: 1,
    entryIds: [133378],
    definitionIds: [{ id: 138164, specId: 258 }],
  },
  MENTAL_FORTITUDE_TALENT: {
    id: 377065,
    name: 'Mental Fortitude',
    icon: 'ability_priest_clarityofpower',
    maxRanks: 1,
    entryIds: [136223],
    definitionIds: [{ id: 140996, specId: 258 }],
  },
  MINDBENDER_DISCIPLINE_TALENT: {
    id: 1280137,
    name: 'Mindbender',
    icon: 'spell_shadow_soulleech_3',
    maxRanks: 1,
    entryIds: [136829],
    definitionIds: [{ id: 141592, specId: 256 }],
  },
  MINDBENDER_SHADOW_TALENT: {
    id: 1230339,
    name: 'Mindbender',
    icon: 'spell_shadow_soulleech_3',
    maxRanks: 1,
    entryIds: [103788],
    definitionIds: [{ id: 108793, specId: 258 }],
  },
  MINDPIERCE_TALENT: {
    id: 1251029,
    name: 'Mindpierce',
    icon: 'spell_shadow_mindshear',
    maxRanks: 1,
    entryIds: [134845],
    definitionIds: [{ id: 139613, specId: 258 }],
  },
  MINDS_EYE_TALENT: {
    id: 407470,
    name: "Mind's Eye",
    icon: 'inv12_ability_priest_powerwordmadness_eye',
    maxRanks: 1,
    entryIds: [103786],
    definitionIds: [{ id: 108791, specId: 258 }],
  },
  MIND_BLAST_TALENT: {
    id: 8092,
    name: 'Mind Blast',
    icon: 'spell_shadow_unholyfrenzy',
    maxRanks: 1,
    entryIds: [103865],
    definitionIds: [{ id: 108870, specId: 258 }],
    manaCost: 3750,
  },
  MIND_CONTROL_TALENT: {
    id: 605,
    name: 'Mind Control',
    icon: 'spell_shadow_shadowworddominate',
    maxRanks: 1,
    entryIds: [103862],
    definitionIds: [{ id: 108867, specId: 258 }],
    manaCost: 5000,
  },
  MIND_DEVOURER_TALENT: {
    id: 373202,
    name: 'Mind Devourer',
    icon: 'spell_arcane_mindmastery',
    maxRanks: 1,
    entryIds: [133550],
    definitionIds: [{ id: 138336, specId: 258 }],
  },
  MIRACLE_WORKER_TALENT: {
    id: 235587,
    name: 'Miracle Worker',
    icon: 'spell_holy_persuitofjustice',
    maxRanks: 1,
    entryIds: [103743],
    definitionIds: [{ id: 108748, specId: 257 }],
  },
  MISERY_TALENT: {
    id: 238558,
    name: 'Misery',
    icon: 'ability_rogue_envelopingshadows',
    maxRanks: 1,
    entryIds: [103809],
    definitionIds: [{ id: 108814, specId: 258 }],
  },
  MOVE_WITH_GRACE_TALENT: {
    id: 390620,
    name: 'Move with Grace',
    icon: 'ability_priest_savinggrace',
    maxRanks: 1,
    entryIds: [103849],
    definitionIds: [{ id: 108854, specId: 258 }],
  },
  NO_ESCAPE_TALENT: {
    id: 451204,
    name: 'No Escape',
    icon: 'spell_fire_twilighthellfire',
    maxRanks: 1,
    entryIds: [117296],
    definitionIds: [{ id: 122308, specId: 258 }],
  },
  OCCULTIST_TALENT: {
    id: 1250293,
    name: 'Occultist',
    icon: 'ability_priest_touchofdecay',
    maxRanks: 1,
    entryIds: [103708],
    definitionIds: [{ id: 108713, specId: 256 }],
  },
  OVERWHELMING_SHADOWS_TALENT: {
    id: 1266883,
    name: 'Overwhelming Shadows',
    icon: 'inv_shadowelementalmount',
    maxRanks: 1,
    entryIds: [136036],
    definitionIds: [{ id: 140791, specId: 258 }],
  },
  PAINFUL_INVOCATION_TALENT: {
    id: 1251030,
    name: 'Painful Invocation',
    icon: 'spell_holy_mindsooth',
    maxRanks: 1,
    entryIds: [103841],
    definitionIds: [{ id: 119742, specId: 258 }],
  },
  PAINFUL_PUNISHMENT_TALENT: {
    id: 390686,
    name: 'Painful Punishment',
    icon: 'ability_priest_clarityofpower',
    maxRanks: 1,
    entryIds: [103726],
    definitionIds: [{ id: 108731, specId: 256 }],
  },
  PAIN_AND_SUFFERING_TALENT: {
    id: 390689,
    name: 'Pain and Suffering',
    icon: 'spell_shadow_shadowwordpain',
    maxRanks: 2,
    entryIds: [103703],
    definitionIds: [{ id: 108708, specId: 256 }],
  },
  PAIN_SUPPRESSION_TALENT: {
    id: 33206,
    name: 'Pain Suppression',
    icon: 'spell_holy_painsupression',
    maxRanks: 1,
    entryIds: [103713],
    definitionIds: [{ id: 108718, specId: 256 }],
    manaCost: 4000,
  },
  PAIN_TRANSFORMATION_TALENT: {
    id: 372991,
    name: 'Pain Transformation',
    icon: 'spell_holy_blessedrecovery',
    maxRanks: 1,
    entryIds: [103715],
    definitionIds: [{ id: 108720, specId: 256 }],
  },
  PERFECTED_FORM_TALENT: {
    id: 453917,
    name: 'Perfected Form',
    icon: 'inv_ability_holyfire_buff',
    maxRanks: 1,
    entryIds: [117280],
    definitionIds: [{ id: 122292, specId: 258 }],
  },
  PETRIFYING_SCREAM_TALENT: {
    id: 55676,
    name: 'Petrifying Scream',
    icon: 'spell_shadow_psychichorrors',
    maxRanks: 1,
    entryIds: [114588],
    definitionIds: [{ id: 119593, specId: 258 }],
  },
  PHANTASM_TALENT: {
    id: 108942,
    name: 'Phantasm',
    icon: 'ability_priest_phantasm',
    maxRanks: 1,
    entryIds: [115883],
    definitionIds: [{ id: 120895, specId: 258 }],
  },
  PHANTOM_MENACE_TALENT: {
    id: 1242779,
    name: 'Phantom Menace',
    icon: 'spell_priest_spectralguise',
    maxRanks: 1,
    entryIds: [103785],
    definitionIds: [{ id: 108790, specId: 258 }],
  },
  PHANTOM_REACH_TALENT: {
    id: 459559,
    name: 'Phantom Reach',
    icon: 'spell_shadow_chilltouch',
    maxRanks: 1,
    entryIds: [103819],
    definitionIds: [{ id: 108824, specId: 258 }],
  },
  PIETY_TALENT: {
    id: 1246802,
    name: 'Piety',
    icon: 'inv_ability_oraclepriest_premonitionpiety',
    maxRanks: 1,
    entryIds: [117303],
    definitionIds: [{ id: 122315, specId: 257 }],
  },
  POWER_INFUSION_TALENT: {
    id: 10060,
    name: 'Power Infusion',
    icon: 'spell_holy_powerinfusion',
    maxRanks: 1,
    entryIds: [103834],
    definitionIds: [{ id: 108839, specId: 258 }],
  },
  POWER_OF_THE_DARK_SIDE_TALENT: {
    id: 198068,
    name: 'Power of the Dark Side',
    icon: 'inv_artifact_powerofthedarkside',
    maxRanks: 1,
    entryIds: [103724],
    definitionIds: [{ id: 108729, specId: 256 }],
  },
  POWER_SURGE_TALENT: {
    id: 453109,
    name: 'Power Surge',
    icon: 'inv_ability_holyfire_groundstate',
    maxRanks: 1,
    entryIds: [117284],
    definitionIds: [{ id: 122296, specId: 258 }],
  },
  POWER_WORD_BARRIER_TALENT: {
    id: 62618,
    name: 'Power Word: Barrier',
    icon: 'spell_holy_powerwordbarrier',
    maxRanks: 1,
    entryIds: [103687],
    definitionIds: [{ id: 108692, specId: 256 }],
    manaCost: 10000,
  },
  POWER_WORD_RADIANCE_TALENT: {
    id: 194509,
    name: 'Power Word: Radiance',
    icon: 'spell_priest_power_word',
    maxRanks: 1,
    entryIds: [103722],
    definitionIds: [{ id: 108727, specId: 256 }],
    manaCost: 13500,
  },
  PRAYERFUL_LITANY_TALENT: {
    id: 391209,
    name: 'Prayerful Litany',
    icon: 'spell_holy_prayerofhealing02',
    maxRanks: 1,
    entryIds: [103769],
    definitionIds: [{ id: 108774, specId: 257 }],
  },
  PRAYERS_OF_THE_VIRTUOUS_TALENT: {
    id: 390977,
    name: 'Prayers of the Virtuous',
    icon: 'spell_holy_prayerofmendingtga',
    maxRanks: 1,
    entryIds: [103750],
    definitionIds: [{ id: 108755, specId: 257 }],
  },
  PRAYER_OF_HEALING_TALENT: {
    id: 596,
    name: 'Prayer of Healing',
    icon: 'spell_holy_prayerofhealing02',
    maxRanks: 1,
    entryIds: [103767],
    definitionIds: [{ id: 108772, specId: 257 }],
    manaCost: 12075,
  },
  PREEMPTIVE_CARE_TALENT: {
    id: 440671,
    name: 'Preemptive Care',
    icon: 'spell_holy_renew',
    maxRanks: 1,
    entryIds: [117277],
    definitionIds: [{ id: 122289, specId: 257 }],
  },
  PREVENTIVE_MEASURES_TALENT: {
    id: 440662,
    name: 'Preventive Measures',
    icon: 'spell_holy_powerwordshield',
    maxRanks: 1,
    entryIds: [117301],
    definitionIds: [{ id: 122313, specId: 257 }],
  },
  PRISMATIC_ECHOES_TALENT: {
    id: 390967,
    name: 'Prismatic Echoes',
    icon: 'spell_holy_aspiration',
    maxRanks: 2,
    entryIds: [103744],
    definitionIds: [{ id: 108749, specId: 257 }],
  },
  PROMPT_PROGNOSIS_TALENT: {
    id: 1246799,
    name: 'Prompt Prognosis',
    icon: 'spell_holy_blessedlife',
    maxRanks: 1,
    entryIds: [117276],
    definitionIds: [{ id: 122288, specId: 257 }],
  },
  PROPHETS_INSIGHT_TALENT: {
    id: 1272359,
    name: "Prophet's Insight",
    icon: 'spell_priest_pontifex',
    maxRanks: 1,
    entryIds: [136041],
    definitionIds: [{ id: 140796, specId: 257 }],
  },
  PROPHETS_WILL_TALENT: {
    id: 433905,
    name: "Prophet's Will",
    icon: 'ability_priest_clarityofpurpose',
    maxRanks: 1,
    entryIds: [117293],
    definitionIds: [{ id: 122305, specId: 257 }],
  },
  PROTECTIVE_LIGHT_TALENT: {
    id: 193063,
    name: 'Protective Light',
    icon: 'spell_holy_holyprotection',
    maxRanks: 1,
    entryIds: [103823],
    definitionIds: [{ id: 108828, specId: 258 }],
  },
  PROTECTOR_OF_THE_FRAIL_TALENT: {
    id: 373035,
    name: 'Protector of the Frail',
    icon: 'ability_racial_forceshield',
    maxRanks: 1,
    entryIds: [103714],
    definitionIds: [{ id: 108719, specId: 256 }],
  },
  PSYCHIC_LINK_TALENT: {
    id: 199484,
    name: 'Psychic Link',
    icon: 'ability_priest_psychiclink',
    maxRanks: 1,
    entryIds: [103806],
    definitionIds: [{ id: 108811, specId: 258 }],
  },
  PSYCHIC_SCREAM_TALENT: {
    id: 8122,
    name: 'Psychic Scream',
    icon: 'spell_shadow_psychicscream',
    maxRanks: 1,
    entryIds: [103851],
    definitionIds: [{ id: 108856, specId: 258 }],
    manaCost: 3000,
  },
  PSYCHIC_VOICE_TALENT: {
    id: 196704,
    name: 'Psychic Voice',
    icon: 'ability_warrior_commandingshout',
    maxRanks: 1,
    entryIds: [103860],
    definitionIds: [{ id: 108865, specId: 258 }],
  },
  PURGE_THE_WICKED_TALENT: {
    id: 1250218,
    name: 'Purge the Wicked',
    icon: 'ability_mage_firestarter',
    maxRanks: 1,
    entryIds: [103690],
    definitionIds: [{ id: 108695, specId: 256 }],
  },
  PURIFY_DISEASE_TALENT: {
    id: 213634,
    name: 'Purify Disease',
    icon: 'spell_holy_nullifydisease',
    maxRanks: 1,
    entryIds: [103854],
    definitionIds: [{ id: 108859, specId: 258 }],
    manaCost: 25000,
  },
  QUICKENED_PULSE_TALENT: {
    id: 1266845,
    name: 'Quickened Pulse',
    icon: 'ability_rogue_sanguinaryvein',
    maxRanks: 1,
    entryIds: [117295],
    definitionIds: [{ id: 122307, specId: 258 }],
  },
  RADIANT_PLEA_TALENT: {
    id: 1250684,
    name: 'Radiant Plea',
    icon: 'spell_priest_pontifex',
    maxRanks: 1,
    entryIds: [103738],
    definitionIds: [{ id: 108743, specId: 257 }],
  },
  REALIZED_POTENTIAL_TALENT: {
    id: 1272326,
    name: 'Realized Potential',
    icon: 'spell_holy_flashheal',
    maxRanks: 1,
    entryIds: [136033],
    definitionIds: [{ id: 140788, specId: 258 }],
  },
  RENEWED_FAITH_TALENT: {
    id: 341997,
    name: 'Renewed Faith',
    icon: 'ability_pvp_innerrenewal',
    maxRanks: 1,
    entryIds: [103780],
    definitionIds: [{ id: 108785, specId: 257 }],
  },
  RESONANT_ENERGY_TALENT: {
    id: 453845,
    name: 'Resonant Energy',
    icon: 'ability_priest_halo',
    maxRanks: 1,
    entryIds: [117279],
    definitionIds: [{ id: 122291, specId: 258 }],
  },
  RESTITUTION_TALENT: {
    id: 391124,
    name: 'Restitution',
    icon: 'inv_staff_2h_artifactheartofkure_d_03',
    maxRanks: 1,
    entryIds: [103773],
    definitionIds: [{ id: 108778, specId: 257 }],
  },
  REVEL_IN_DARKNESS_TALENT: {
    id: 373003,
    name: 'Revel in Darkness',
    icon: 'ability_rogue_envelopingshadows',
    maxRanks: 1,
    entryIds: [103705],
    definitionIds: [{ id: 108710, specId: 256 }],
  },
  SANCTUARY_TALENT: {
    id: 231682,
    name: 'Sanctuary',
    icon: 'spell_holy_holysmite',
    maxRanks: 1,
    entryIds: [108225],
    definitionIds: [{ id: 113230, specId: 256 }],
  },
  SANGUINE_TEACHINGS_TALENT: {
    id: 373218,
    name: 'Sanguine Teachings',
    icon: 'inv_archaeology_80_zandalari_sanguinetotem',
    maxRanks: 1,
    entryIds: [134860],
    definitionIds: [{ id: 139628, specId: 258 }],
  },
  SAVE_THE_DAY_TALENT: {
    id: 440669,
    name: 'Save the Day',
    icon: 'priest_spell_leapoffaith_a',
    maxRanks: 1,
    entryIds: [119331],
    definitionIds: [{ id: 124231, specId: 257 }],
  },
  SAY_YOUR_PRAYERS_TALENT: {
    id: 391186,
    name: 'Say Your Prayers',
    icon: 'ability_priest_bindingprayers',
    maxRanks: 1,
    entryIds: [103749],
    definitionIds: [{ id: 108754, specId: 257 }],
  },
  SCREAMS_OF_THE_VOID_TALENT: {
    id: 375767,
    name: 'Screams of the Void',
    icon: 'spell_shadow_lifedrain02_purple',
    maxRanks: 2,
    entryIds: [103789],
    definitionIds: [{ id: 108794, specId: 258 }],
  },
  SEARING_LIGHT_TALENT: {
    id: 1280131,
    name: 'Searing Light',
    icon: 'spell_holy_penance',
    maxRanks: 1,
    entryIds: [103712],
    definitionIds: [{ id: 108717, specId: 256 }],
  },
  SERAPHIC_CRESCENDO_TALENT: {
    id: 419110,
    name: 'Seraphic Crescendo',
    icon: 'spell_holy_divinehymn',
    maxRanks: 1,
    entryIds: [103747],
    definitionIds: [{ id: 108752, specId: 257 }],
  },
  SHACKLE_HORROR_TALENT: {
    id: 9484,
    name: 'Shackle Horror',
    icon: 'spell_nature_slow',
    maxRanks: 1,
    entryIds: [103843],
    definitionIds: [{ id: 108848, specId: 258 }],
    manaCost: 3000,
  },
  SHADOWFIEND_TALENT: {
    id: 34433,
    name: 'Shadowfiend',
    icon: 'spell_shadow_shadowfiend',
    maxRanks: 1,
    entryIds: [103695, 134851],
    definitionIds: [
      { id: 108700, specId: 256 },
      { id: 139619, specId: 258 },
    ],
  },
  SHADOWY_APPARITIONS_TALENT: {
    id: 341491,
    name: 'Shadowy Apparitions',
    icon: 'ability_priest_shadowyapparition',
    maxRanks: 1,
    entryIds: [103792],
    definitionIds: [{ id: 108797, specId: 258 }],
  },
  SHADOWY_INSIGHT_TALENT: {
    id: 375888,
    name: 'Shadowy Insight',
    icon: 'spell_shadow_possession',
    maxRanks: 1,
    entryIds: [103813],
    definitionIds: [{ id: 108818, specId: 258 }],
  },
  SHADOW_MEND_TALENT: {
    id: 1252215,
    name: 'Shadow Mend',
    icon: 'spell_shadow_shadowmend',
    maxRanks: 1,
    entryIds: [103692],
    definitionIds: [{ id: 108697, specId: 256 }],
  },
  SHADOW_TAP_TALENT: {
    id: 1235211,
    name: 'Shadow Tap',
    icon: 'ability_creature_disease_05',
    maxRanks: 1,
    entryIds: [103706],
    definitionIds: [{ id: 108711, specId: 256 }],
  },
  SHADOW_WORD_DEATH_TALENT: {
    id: 32379,
    name: 'Shadow Word: Death',
    icon: 'spell_shadow_demonicfortitude',
    maxRanks: 1,
    entryIds: [103864],
    definitionIds: [{ id: 108869, specId: 258 }],
  },
  SHADOW_WORD_MADNESS_TALENT: {
    id: 335467,
    name: 'Shadow Word: Madness',
    icon: 'inv12_ability_priest_powerwordmadness_eye',
    maxRanks: 1,
    entryIds: [103808],
    definitionIds: [{ id: 108813, specId: 258 }],
    insanityCost: 5000,
  },
  SHATTERED_PSYCHE_TALENT: {
    id: 391090,
    name: 'Shattered Psyche',
    icon: 'inv_ability_priest_mindgames',
    maxRanks: 1,
    entryIds: [133400],
    definitionIds: [{ id: 138186, specId: 258 }],
  },
  SHEER_TERROR_TALENT: {
    id: 390919,
    name: 'Sheer Terror',
    icon: 'spell_nzinsanity_fearofdeath',
    maxRanks: 1,
    entryIds: [103845],
    definitionIds: [{ id: 108850, specId: 258 }],
  },
  SHIELD_DISCIPLINE_TALENT: {
    id: 197045,
    name: 'Shield Discipline',
    icon: 'spell_holy_divineprotection',
    maxRanks: 1,
    entryIds: [103717],
    definitionIds: [{ id: 108722, specId: 256 }],
  },
  SHOCK_PULSE_TALENT: {
    id: 453852,
    name: 'Shock Pulse',
    icon: 'spell_priest_pathofdevout',
    maxRanks: 1,
    entryIds: [117289],
    definitionIds: [{ id: 122301, specId: 258 }],
  },
  SPECTRAL_HORRORS_TALENT: {
    id: 407469,
    name: 'Spectral Horrors',
    icon: 'ability_priest_phantasm',
    maxRanks: 1,
    entryIds: [103686],
    definitionIds: [{ id: 108691, specId: 258 }],
  },
  SPECTRAL_ILLUSION_TALENT: {
    id: 1250378,
    name: 'Spectral Illusion',
    icon: 'spell_priest_spectralguise',
    maxRanks: 1,
    entryIds: [134848],
    definitionIds: [{ id: 139616, specId: 258 }],
  },
  SPELL_WARDING_TALENT: {
    id: 390667,
    name: 'Spell Warding',
    icon: 'spell_holy_spellwarding',
    maxRanks: 2,
    entryIds: [134844],
    definitionIds: [{ id: 139612, specId: 258 }],
  },
  SPIRITUAL_GUIDANCE_TALENT: {
    id: 1250818,
    name: 'Spiritual Guidance',
    icon: 'spell_holy_spiritualguidence',
    maxRanks: 1,
    entryIds: [103818],
    definitionIds: [{ id: 108823, specId: 258 }],
  },
  SPIRITWELL_TALENT: {
    id: 1247178,
    name: 'Spiritwell',
    icon: 'spell_holy_prayerofhealing02',
    maxRanks: 1,
    entryIds: [136688],
    definitionIds: [{ id: 141460, specId: 258 }],
  },
  STRENGTH_OF_RESOLVE_TALENT: {
    id: 1250820,
    name: 'Strength of Resolve',
    icon: 'spell_holy_ashestoashes',
    maxRanks: 1,
    entryIds: [103837],
    definitionIds: [{ id: 108842, specId: 258 }],
  },
  SUBSERVIENT_SHADOWS_TALENT: {
    id: 1228516,
    name: 'Subservient Shadows',
    icon: 'inv_hivemind',
    maxRanks: 1,
    entryIds: [103682],
    definitionIds: [{ id: 108687, specId: 258 }],
  },
  SURGE_OF_INSANITY_TALENT: {
    id: 391399,
    name: 'Surge of Insanity',
    icon: 'spell_fire_twilightflamebreath',
    maxRanks: 1,
    entryIds: [103812],
    definitionIds: [{ id: 108817, specId: 258 }],
  },
  SURGE_OF_LIGHT_TALENT: {
    id: 109186,
    name: 'Surge of Light',
    icon: 'spell_holy_surgeoflight',
    maxRanks: 1,
    entryIds: [103868],
    definitionIds: [{ id: 108873, specId: 258 }],
  },
  SUSTAINED_POTENCY_TALENT: {
    id: 454001,
    name: 'Sustained Potency',
    icon: 'ability_priest_ascension',
    maxRanks: 1,
    entryIds: [125085],
    definitionIds: [{ id: 129917, specId: 258 }],
  },
  TENTACLE_SLAM_TALENT: {
    id: 1227280,
    name: 'Tentacle Slam',
    icon: 'inv12_ability_priest_tentacleslam',
    maxRanks: 1,
    entryIds: [115448],
    definitionIds: [{ id: 120460, specId: 258 }],
  },
  THOUGHT_HARVESTER_TALENT: {
    id: 406788,
    name: 'Thought Harvester',
    icon: 'spell_shadow_unholyfrenzy',
    maxRanks: 1,
    entryIds: [103795],
    definitionIds: [{ id: 108800, specId: 258 }],
  },
  TITHE_EVASION_TALENT: {
    id: 373223,
    name: 'Tithe Evasion',
    icon: 'spell_nzinsanity_bloodthirst',
    maxRanks: 1,
    entryIds: [103863],
    definitionIds: [{ id: 108868, specId: 258 }],
  },
  TORMENTED_SPIRITS_TALENT: {
    id: 391284,
    name: 'Tormented Spirits',
    icon: 'spell_shadow_painandsuffering',
    maxRanks: 1,
    entryIds: [103810],
    definitionIds: [{ id: 108815, specId: 258 }],
  },
  TORMENTING_WHISPERS_TALENT: {
    id: 1250492,
    name: 'Tormenting Whispers',
    icon: 'spell_shadow_painandsuffering',
    maxRanks: 1,
    entryIds: [103801],
    definitionIds: [{ id: 108806, specId: 258 }],
  },
  TOUCH_OF_THE_VOID_TALENT: {
    id: 1266856,
    name: 'Touch of the Void',
    icon: 'inv_112_raidtrinkets_blobofswirlingvoid_purple',
    maxRanks: 1,
    entryIds: [136037],
    definitionIds: [{ id: 140792, specId: 258 }],
  },
  TRAIL_OF_LIGHT_TALENT: {
    id: 200128,
    name: 'Trail of Light',
    icon: 'ability_priest_wordsofmeaning',
    maxRanks: 1,
    entryIds: [128613],
    definitionIds: [{ id: 133416, specId: 257 }],
  },
  TRANSLUCENT_IMAGE_TALENT: {
    id: 373446,
    name: 'Translucent Image',
    icon: 'spell_shadow_twistedfaith',
    maxRanks: 1,
    entryIds: [103835],
    definitionIds: [{ id: 108840, specId: 258 }],
  },
  TWINSIGHT_TALENT: {
    id: 440742,
    name: 'Twinsight',
    icon: 'inv_ability_oraclepriest_clairvoyance',
    maxRanks: 1,
    entryIds: [117290],
    definitionIds: [{ id: 122302, specId: 257 }],
  },
  TWINS_OF_THE_SUN_PRIESTESS_TALENT: {
    id: 373466,
    name: 'Twins of the Sun Priestess',
    icon: 'spell_fire_felflamering_red',
    maxRanks: 1,
    entryIds: [134284],
    definitionIds: [{ id: 139057, specId: 258 }],
  },
  TWIN_DISCIPLINES_TALENT: {
    id: 1251077,
    name: 'Twin Disciplines',
    icon: 'ability_priest_innerlightandshadow',
    maxRanks: 1,
    entryIds: [103840],
    definitionIds: [{ id: 108845, specId: 258 }],
  },
  TWIST_OF_FATE_TALENT: {
    id: 390972,
    name: 'Twist of Fate',
    icon: 'spell_shadow_mindtwisting',
    maxRanks: 2,
    entryIds: [103833],
    definitionIds: [{ id: 108838, specId: 258 }],
  },
  ULTIMATE_PENITENCE_TALENT: {
    id: 421453,
    name: 'Ultimate Penitence',
    icon: 'ability_priest_ascendance',
    maxRanks: 1,
    entryIds: [116182],
    definitionIds: [{ id: 121194, specId: 256 }],
  },
  ULTIMATE_SERENITY_TALENT: {
    id: 1246517,
    name: 'Ultimate Serenity',
    icon: 'ability_priest_holywordlife',
    maxRanks: 1,
    entryIds: [103733],
    definitionIds: [{ id: 108738, specId: 257 }],
  },
  UNFOLDING_VISION_TALENT: {
    id: 1272363,
    name: 'Unfolding Vision',
    icon: 'spell_holy_mindvision',
    maxRanks: 1,
    entryIds: [136039],
    definitionIds: [{ id: 140794, specId: 257 }],
  },
  UNWAVERING_WILL_TALENT: {
    id: 373456,
    name: 'Unwavering Will',
    icon: 'ability_warrior_unrelentingassault',
    maxRanks: 2,
    entryIds: [103847],
    definitionIds: [{ id: 108852, specId: 258 }],
  },
  UPLIFTING_WORDS_TALENT: {
    id: 1250562,
    name: 'Uplifting Words',
    icon: 'spell_holy_persecution',
    maxRanks: 1,
    entryIds: [103756],
    definitionIds: [{ id: 108761, specId: 257 }],
  },
  VOICE_OF_HARMONY_TALENT: {
    id: 390994,
    name: 'Voice of Harmony',
    icon: 'ability_priest_heavanlyvoice',
    maxRanks: 1,
    entryIds: [103754],
    definitionIds: [{ id: 108759, specId: 257 }],
  },
  VOIDFORM_TALENT: {
    id: 228260,
    name: 'Voidform',
    icon: 'spell_priest_void_blast',
    maxRanks: 1,
    entryIds: [103674],
    definitionIds: [{ id: 108679, specId: 258 }],
  },
  VOIDHEART_TALENT: {
    id: 449880,
    name: 'Voidheart',
    icon: 'inv_cosmicvoid_orb',
    maxRanks: 1,
    entryIds: [136038],
    definitionIds: [{ id: 140793, specId: 258 }],
  },
  VOIDTOUCHED_TALENT: {
    id: 407430,
    name: 'Voidtouched',
    icon: 'inv_enchant_voidsphere',
    maxRanks: 1,
    entryIds: [133542],
    definitionIds: [{ id: 138328, specId: 258 }],
  },
  VOIDWRAITH_TALENT: {
    id: 451234,
    name: 'Voidwraith',
    icon: 'warlock_curse_shadow',
    maxRanks: 1,
    entryIds: [123841],
    definitionIds: [{ id: 128679, specId: 258 }],
  },
  VOID_APPARITIONS_1_SHADOW_TALENT: {
    id: 1264096,
    name: 'Void Apparitions',
    icon: 'inv12_apextalent_priest_voidapparitions',
    maxRanks: 1,
    entryIds: [136992],
    definitionIds: [{ id: 141755, specId: 258 }],
  },
  VOID_APPARITIONS_2_SHADOW_TALENT: {
    id: 1264104,
    name: 'Void Apparitions',
    icon: 'inv12_apextalent_priest_voidapparitions',
    maxRanks: 2,
    entryIds: [136991],
    definitionIds: [{ id: 141754, specId: 258 }],
  },
  VOID_APPARITIONS_3_SHADOW_TALENT: {
    id: 1264107,
    name: 'Void Apparitions',
    icon: 'inv12_apextalent_priest_voidapparitions',
    maxRanks: 1,
    entryIds: [136990],
    definitionIds: [{ id: 141753, specId: 258 }],
  },
  VOID_BLAST_TALENT: {
    id: 450405,
    name: 'Void Blast',
    icon: 'inv_cosmicvoid_missile',
    maxRanks: 1,
    entryIds: [117306],
    definitionIds: [{ id: 122318, specId: 258 }],
  },
  VOID_EMPOWERMENT_TALENT: {
    id: 450138,
    name: 'Void Empowerment',
    icon: 'inv_cosmicvoid_nova',
    maxRanks: 1,
    entryIds: [125821],
    definitionIds: [{ id: 128681, specId: 258 }],
  },
  VOID_INFUSION_TALENT: {
    id: 450612,
    name: 'Void Infusion',
    icon: 'inv_misc_volatileshadow',
    maxRanks: 1,
    entryIds: [117272],
    definitionIds: [{ id: 122284, specId: 258 }],
  },
  VOID_LEECH_TALENT: {
    id: 451311,
    name: 'Void Leech',
    icon: 'spell_shadow_soulleech_2',
    maxRanks: 1,
    entryIds: [117299],
    definitionIds: [{ id: 122311, specId: 258 }],
  },
  VOID_TENDRILS_TALENT: {
    id: 1250691,
    name: 'Void Tendrils',
    icon: 'spell_priest_voidtendrils',
    maxRanks: 1,
    entryIds: [103859],
    definitionIds: [{ id: 108864, specId: 258 }],
  },
  VOID_TORRENT_TALENT: {
    id: 263165,
    name: 'Void Torrent',
    icon: 'spell_priest_voidsear',
    maxRanks: 1,
    entryIds: [117287],
    definitionIds: [{ id: 122299, specId: 258 }],
  },
  WASTE_NO_TIME_TALENT: {
    id: 440681,
    name: 'Waste No Time',
    icon: 'spell_nature_timestop',
    maxRanks: 1,
    entryIds: [117282],
    definitionIds: [{ id: 122294, specId: 257 }],
  },
  WEAL_AND_WOE_TALENT: {
    id: 390786,
    name: 'Weal and Woe',
    icon: 'spell_priest_burningwill',
    maxRanks: 1,
    entryIds: [103698],
    definitionIds: [{ id: 108703, specId: 256 }],
  },
  WORDS_OF_THE_WISE_TALENT: {
    id: 1272352,
    name: 'Words of the Wise',
    icon: 'spell_priest_power_word',
    maxRanks: 1,
    entryIds: [136040],
    definitionIds: [{ id: 140795, specId: 257 }],
  },
  WORD_OF_SUPREMACY_TALENT: {
    id: 453726,
    name: 'Word of Supremacy',
    icon: 'spell_holy_wordfortitude',
    maxRanks: 1,
    entryIds: [136034],
    definitionIds: [{ id: 140789, specId: 258 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_PRIEST };
